import { ReduxStore } from 'store/types';

function importSpreadsheetIsLoading(state: ReduxStore): boolean {
  return state.manufacturer.importSpreadsheet.config.isLoading;
}

export default importSpreadsheetIsLoading;
